import { render, staticRenderFns } from "./KitchenLogin.vue?vue&type=template&id=3a6b43d0&scoped=true&"
import script from "./KitchenLogin.vue?vue&type=script&lang=js&"
export * from "./KitchenLogin.vue?vue&type=script&lang=js&"
import style0 from "./KitchenLogin.vue?vue&type=style&index=0&id=3a6b43d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6b43d0",
  null
  
)

export default component.exports